// Confiance.jsx
import React, { useMemo } from "react";
import LogoWallSlider from "../LogoWallSlider";

export default function Confiance({ confiance = [], loading = false }) {
  const items = useMemo(
    () => (Array.isArray(confiance) ? confiance.filter((x) => Number(x.type) === 0) : []),
    [confiance]
  );

  return (
    <LogoWallSlider
      items={items}
      loading={loading}
      title="Ils nous font"
      highlight="confiance"
      subtitle="Références clients et institutions : projets livrés, déploiements terrain et accompagnement continu."
    />
  );
}
